// extracted by mini-css-extract-plugin
export default {"wrapper":"modalContainerWrapper_wrapper__fvda6","title":"modalContainerWrapper_title__ZOw3x"};